import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@jsverse/transloco';
import { Injectable, OnDestroy } from '@angular/core';
import { filter } from 'rxjs/operators';
import { Subscription, combineLatest } from 'rxjs';

@Injectable()
export class CustomPaginatorIntl extends MatPaginatorIntl implements OnDestroy {
    sub = new Subscription();
    constructor(private translate: TranslocoService) {
        super();

        this.sub.add(
            combineLatest([
                this.translate.load('en'),
                this.translate.load('de'),
                this.translate.events$.pipe(filter((e) => e.type === 'translationLoadSuccess')),
            ]).subscribe(() => {
                this.getAndInitTranslations();
            })
        );
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    getRangeLabel = (page: number, pageSize: number, length: number): string => {
        if (length === 0 || pageSize === 0) {
            return `0 / ${length}`;
        }

        length = Math.max(length, 0);

        const startIndex: number = page * pageSize;
        const endIndex: number = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

        return this.translate.translate('PAGINATOR.RANGE', {
            startIndex: startIndex + 1,
            endIndex,
            length,
        });
    };

    getAndInitTranslations(): void {
        this.itemsPerPageLabel = this.translate.translate('PAGINATOR.ITEMS_PER_PAGE');
        this.nextPageLabel = this.translate.translate('PAGINATOR.NEXT_PAGE');
        this.previousPageLabel = this.translate.translate('PAGINATOR.PREVIOUS_PAGE');
        this.firstPageLabel = this.translate.translate('PAGINATOR.FIRST_PAGE');
        this.lastPageLabel = this.translate.translate('PAGINATOR.LAST_PAGE');
        this.changes.next();
    }
}
